// No direct PHP counterpart.
// JS discovery index for the sibling PHP unit files in this directory tree.
var requireSort = require.context('.', true, /\.js$/)
var sorts = []

requireSort.keys().forEach(function(filename) {
	if (filename === './index.js') return

	var mod = requireSort(filename)
	var sort = mod.default || mod

	if (sort && typeof sort.require === 'function' && typeof sort.run === 'function') {
		sorts.push(sort)
	}
})

sorts.sort(function(a, b) {
	return (a.priority || 50) - (b.priority || 50)
})

export function querySorts() {
	return sorts
}
